<template>
  <div class="root-box">
    <el-table :data="displayList" stripe :max-height="tableHeight" :row-class-name="rowClassName">
      <el-table-column label="序号" width="80" class-name="order-index-col">
        <template slot-scope="scope">
          <div class="order-index-hit" :title="scope.row.id ? '点击复制订单号' : ''" @click="copyOrderId(scope.row.id)">{{
            scope.$index + 1 }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="date" width="100" label="日期"></el-table-column>
      <el-table-column prop="pathId" width="120" label="路线">
        <template slot-scope="scope">{{ scope.row.pathId | pathNameTransfer }}</template>
      </el-table-column>
      <el-table-column prop="showTime" width="120" label="时间"></el-table-column>
      <el-table-column prop="orderSource" width="100" label="渠道">
        <template slot-scope="scope">
          <div v-order-source="scope.row.orderSource"></div>
          <vip-label :vip="scope.row.vip" />
        </template>
      </el-table-column>
      <el-table-column prop="number" width="60" label="订票">
        <template slot-scope="scope">
          {{ scope.row | orderTypeTransfer }}
        </template>
      </el-table-column>
      <el-table-column prop="price" width="100" label="总价">
        <template slot-scope="scope">{{ scope.row.price | moneyFormat }}元</template>
      </el-table-column>
      <el-table-column prop="telephone" width="130" label="手机">
        <template slot-scope="scope">
          <tel-cell :order="scope.row" />
        </template>
      </el-table-column>
      <el-table-column prop="departure" label="起点"></el-table-column>
      <el-table-column prop="destination" label="终点"></el-table-column>
      <el-table-column width="100" prop="createTime" label="下单时间"></el-table-column>
      <el-table-column label="操作" width="80" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="$emit('assign', scope.row)">分派</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <span class="pagination-sum">共{{ list.length }}单， {{ totalPerson }}人</span>
    </div>
  </div>
</template>

<script>
import TelCell from "@/components/TelCell";
import { Toolkit } from "@/util";
import { matchTelKeyword } from "../../utils/simulate";

export default {
  components: { TelCell },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    date: {
      type: String,
      default: ""
    },
    tableHeight: {
      type: Number,
      default: 480
    },
    highlightTel: {
      type: String,
      default: ""
    }
  },
  computed: {
    displayList() {
      return (this.list || []).map((item) => ({
        ...item,
        date: this.date || item.date
      }));
    },
    totalPerson() {
      return (this.list || []).reduce((sum, item) => sum + (item.number || 0), 0);
    }
  },
  methods: {
    rowClassName({ row }) {
      return matchTelKeyword(row, this.highlightTel) ? "tel-highlight-row" : "";
    },
    copyOrderId(orderId) {
      if (!orderId) {
        return;
      }
      Toolkit.copyContentH5(String(orderId));
      this.$message.success("订单号已复制");
    }
  }
};
</script>

<style lang="less" scoped>
.root-box {
  height: 100%;
  overflow: hidden;
}

.page {
  padding-top: 4px;
  line-height: 20px;
  box-sizing: border-box;
  height: 28px;
}

.order-index-hit {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 40px;
  margin: -8px -10px;
  padding: 8px 10px;
  box-sizing: content-box;
  cursor: pointer;
}

.pagination-sum {
  color: #f56c6c;
  font-size: 15px;
  display: inline-block;
}

.red {
  color: #f56c6c;
}

/deep/ .tel-highlight-row {
  background: #fff7e6 !important;

  td {
    background: #fff7e6 !important;
  }
}

/deep/ .el-table--striped .tel-highlight-row.el-table__row--striped td {
  background: #fff3d6 !important;
}
</style>
